var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showsModal)?_c('SimpleModal',{on:{"close":function($event){_vm.showsModal = false}}},[_c('p',[_vm._v(_vm._s(_vm.readyMessage))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }